import { render, staticRenderFns } from "./assicurazione-medico-bagaglio.vue?vue&type=template&id=0293c401&scoped=true"
import script from "./assicurazione-medico-bagaglio.vue?vue&type=script&lang=js"
export * from "./assicurazione-medico-bagaglio.vue?vue&type=script&lang=js"
import style0 from "./assicurazione-medico-bagaglio.vue?vue&type=style&index=0&id=0293c401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0293c401",
  null
  
)

export default component.exports